import { Link } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { img } from "@/lib/api";
import { Emblem } from "@/components/Logo";
import { Cta } from "@/components/Cta";
import { Reveal } from "@/components/Reveal";

export const Details = () => {
  const { site } = useStore();
  const d = site.details;
  return (
    <section id="story" data-testid="details-section" className="bg-berry text-pearl py-16 lg:py-24 relative overflow-hidden grain scroll-mt-24">
      <p aria-hidden className="absolute -bottom-10 left-0 right-0 text-center font-display font-semibold text-[22vw] leading-none tracking-[0.08em] text-pearl/[0.06] select-none whitespace-nowrap">RATNAHARA</p>
      <div className="container-rh grid lg:grid-cols-12 gap-12 lg:gap-16 items-center relative">
        <Reveal className="lg:col-span-5">
          <Emblem className="w-14 h-12" color="#F8F4EF" gem="var(--rh-accent)" />
          <h2 className="font-display font-medium text-[44px] sm:text-[58px] lg:text-[68px] leading-[0.98] mt-8" data-testid="details-heading">{d.heading}</h2>
          <p className="mt-7 text-[18px] leading-relaxed text-pearl/85 max-w-md">{d.text}</p>
          <p className="mt-10 font-display italic text-[24px] text-champagne">Jewels that tell your story.</p>
        </Reveal>
        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4 items-center">
          <Reveal className="w-fit max-w-full mx-auto rounded-[28px] overflow-hidden">
            <img src={img(d.image)} alt="Jewellery detail" loading="lazy" className="block w-auto max-w-full h-auto max-h-[calc(100vh-240px)]" data-testid="details-image" />
          </Reveal>
          {d.image2 && (
            <Reveal delay={0.15} className="w-fit max-w-full mx-auto rounded-[22px] overflow-hidden">
              <img src={img(d.image2)} alt="Jewellery detail" loading="lazy" className="block w-auto max-w-full h-auto max-h-[calc(100vh-240px)]" data-testid="details-image-2" />
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
};

export const FinalCta = () => {
  const { site, products } = useStore();
  const f = site.final;
  return (
    <section data-testid="final-cta-section" className="bg-pearl py-16 lg:py-24">
      <div className="container-rh">
        <Reveal className="grid lg:grid-cols-12 items-center rounded-[28px] overflow-hidden bg-rose">
          <div className="lg:col-span-7 p-8 sm:p-12 lg:p-16 flex flex-col justify-center order-2 lg:order-1">
            <p className="eyebrow text-berry mb-5">The Selected Three</p>
            <h2 className="font-display font-medium text-[42px] sm:text-[58px] lg:text-[72px] leading-[0.96]" data-testid="final-cta-heading">{f.heading}</h2>
            <div className="mt-10 flex flex-wrap items-center gap-6">
              <Cta to="/shop" label={f.cta} size="lg" testId="final-cta-button" />
              <div className="flex gap-2">
                {products.slice(0, 3).map((p) => (
                  <Link key={p.id} to={`/product/${p.slug}`} className="w-14 h-14 rounded-[14px] overflow-hidden ring-2 ring-pearl/70 hover:-translate-y-1 transition-transform">
                    <img src={img(p.images[0])} alt={p.name} className="w-full h-full object-cover" />
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <div className="lg:col-span-5 order-1 lg:order-2 p-3 flex justify-center">
            <img src={img(f.image)} alt="" loading="lazy" className="fit-view rounded-[22px]" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
